import { render, staticRenderFns } from "./HystoricalData.vue?vue&type=template&id=c4831b86&"
import script from "./HystoricalData.vue?vue&type=script&lang=js&"
export * from "./HystoricalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports